/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import Label from "../../../Components/Control/Label";
import {Tool} from "../../../App";
import ModalPrint from "../ModalPrint";
import Notif from "../../../Components/Notif";
import Select from "../../../Components/Control/Select";
import Patient from "../../../Server/Patient";
import {HospitalWashRequest, OrganizationWashRequest, SectionWashRequest} from '../../../Server/WashRequest';
import InputButton from '../../../Components/Control/InputButton';
import MyComponent from '../../../Components/MyComponent';

class ModalWashRequest extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            error: null,
            loading: null,
            diagnostics: [
                {id: '', text: '...'},
                ...props.base.patientDiagnostics.sort((a, b) => a.ordering - b.ordering).map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            modalPrint: React.createRef(),
            patientFileCode: React.createRef(),
            patientDiagnosticId: React.createRef(),
            patientDiagnosticStr: React.createRef(),
            requestReasonStr: React.createRef(),
            docterId: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            printLabel: React.createRef(),
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        patientFileCode: x => Boolean(x) || 'شماره پرونده بیمار وارد نشده است.',
        patientDiagnosticId: x => Boolean(x[0]?.id) || 'نحوه تجویز وارد نشده است',
        patientDiagnosticStr: x => {
            const pdi = (this.state?.fields?.patientDiagnosticId || [])[0]?.id == 5;
            return !pdi || (pdi && Boolean(x)) || 'نحوه تجویز وارد نشده است';
        },
        requestReasonStr: x => Boolean(x) || 'علت درخواست وارد نشده است.',
        docterId: x => Boolean(x?.[0]?.id) || 'نام پزشک انتخاب نشده است.'
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            state.patientFileInfo !== nextState.patientFileInfo ||
            props.base.normRequestFormPrintOnSubmit !== nextProps.base.normRequestFormPrintOnSubmit;
    }

    render() {
        const {state, props} = this;
        const readOnly = state.action === ModalAction.VIEW;
        const age = state.data?.patientBirthDate || state?.patientFileInfo?.patientBirthDate ? moment().diff(moment(state.data?.patientBirthDate || state?.patientFileInfo?.patientBirthDate, 'jYYYY-jMM-jDD'), 'year') : null;
        const products = [];
        const doctors = [
            {id:'',text:'...'},
            ...props.base.doctors
        ];

        if (state.data?.sectionWashedRequestForm_ProductsVM)
            for (let i = 0; i < state.data?.sectionWashedRequestForm_ProductsVM.length; i += 2) {
                products.push([
                    state.data?.sectionWashedRequestForm_ProductsVM[i] || {},
                    state.data?.sectionWashedRequestForm_ProductsVM[i + 1] || {}
                ]);
            }

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalWashRequest'}
                   size={'large'}
                   title={'فرم درخواست خون شسته'}
                   required={true}
                   error={this.state.error}
                   loading={this.state.loading}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <table>
                        <tbody>
                        <tr>
                            <td colSpan={6}>
                                <div className={'dis-f'}>
                                    <div className={'flex ali-c'} style={{fontSize: 13, fontWeight: 500}}>فرم درخواست خون شسته</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={6}>
                                <div className={'dis-f'}>
                                    <Label className={'bt bl br'} size={'medium'} style={{backgroundColor: "#ececec", padding: '5px 10px'}}>این قسمت توسط بیمارستان تکمیل شود.</Label>
                                    <div className="flex"/>
                                </div>
                            </td>
                        </tr>
                        <tr className={'bt bl br'}>
                            <td colSpan={2}><Input className={'pad-4'} label={'نام و نام خانوادگی بیمار'} readOnly={true} value={state.data?.patientFullName || state?.patientFileInfo?.patientFullName}/></td>
                            <td><Input className={'pad-4'} label={'بیمارستان'} readOnly={true} value={props.user?.hospitalFullName}/></td>
                            <td><Input className={'pad-4'} label={'سن'} readOnly={true} value={age ? `${age} سال` : ''}/></td>
                            <td colSpan={2}><Input direction={"ltr"} className={'pad-4'} label={'گروه خونی و Rh بیمار'} readOnly={true} value={state.data?.patientBloodGroupStr || state?.patientFileInfo?.patientBloodGroupStr}/></td>
                        </tr>
                        <tr className={'bl br'}>
                            {/*<td colSpan={2}><Input ref={this.ref.patientFileCode} className={'pad-4'} label={'شماره پرونده'} readOnly={readOnly} value={state.data?.patientFileCode || state?.fields?.patientFileCode} validation={this.validations.patientFileCode} onChange={this.setFiel.bind(this, 'patientFileCode')} onEnter={this.patientFileCodeSubmitHandler.bind(this)} onBlur={this.patientFileCodeSubmitHandler.bind(this)}/></td>*/}
                            <td colSpan={2}><InputButton ref={this.ref.patientFileCode} className={'pad-4'} label={'شماره پرونده'} readOnly={readOnly} value={state.data?.patientFileCode || state?.fields?.patientFileCode} validation={this.validations.patientFileCode} onChange={this.setField.bind(this, 'patientFileCode')} onEnter={this.patientFileCodeSubmitHandler.bind(this)} buttonTitle={'جستجو'} onButtonClick={this.patientFileCodeSubmitHandler.bind(this)}/></td>
                            <td colSpan={2}>
                                <div className={'dis-f'}>
                                    <Select ref={this.ref.patientDiagnosticId} className={'pad-4 fb-5'} label={'تشخیص بیماری'} readOnly={readOnly} options={state.diagnostics} value={state.fields?.patientDiagnosticId} validation={this.validations?.patientDiagnosticId} onChange={this.setField.bind(this, 'patientDiagnosticId')}/>
                                    <Input ref={this.ref.patientDiagnosticStr} className={'pad-4 fb-15'} label={'توضیحات بیماری'} readOnly={readOnly} disabled={(state?.fields?.patientDiagnosticId || [])[0]?.id != 5} options={state.diagnostics} value={state.fields?.patientDiagnosticStr} validation={this.validations?.patientDiagnosticStr} onChange={this.setField.bind(this, 'patientDiagnosticStr')}/>
                                </div>
                            </td>
                            <td colSpan={2}><Input align={"center"} direction={"ltr"} className={'pad-4'} label={'تاریخ و ساعت درخواست'} readOnly={true} value={moment(state.data?.createDateTime || undefined).format('jYYYY-jMM-jDD HH:mm:ss')}/></td>
                        </tr>
                        <tr className={'br bl bb'}>
                            <td colSpan={5}><Input ref={this.ref.requestReasonStr} className={'pad-4'} label={'علت درخواست'} readOnly={readOnly} value={state?.fields?.requestReasonStr} validation={this.validations.requestReasonStr} onChange={this.setField.bind(this, 'requestReasonStr')}/></td>
                            <td><Select ref={this.ref.docterId} className={'pad-4'} label={'نام پزشک معالج'} readOnly={readOnly} options={doctors} value={state?.fields?.docterId} validation={this.validations.docterId} onChange={this.setField.bind(this, 'docterId')}/></td>
                        </tr>
                        {products.length > 0 ? <React.Fragment>
                            <tr className={'bl br bb'}>
                                <td colSpan={1} className={'bl'}><Label style={{lineHeight: '30px'}}>شماره فرآورده</Label></td>
                                <td colSpan={2} className={'bl'}><Label style={{lineHeight: '30px'}}>گروه خونی فرآورده</Label></td>
                                <td colSpan={1} className={'bl'}><Label style={{lineHeight: '30px'}}>شماره فرآورده</Label></td>
                                <td colSpan={2}><Label style={{lineHeight: '30px'}}>گروه خونی فرآورده</Label></td>
                            </tr>
                            {products.map(items => <tr className={'bl br bb'}>
                                <td colSpan={1} className={'bl'}><Label style={{lineHeight: '25px', textAlign: 'center'}}>{items[0].productNumber}</Label></td>
                                <td colSpan={2} className={'bl'}><Label style={{lineHeight: '25px', textAlign: 'center'}}>{items[0].productBloodGroupStr}</Label></td>
                                <td colSpan={1} className={'bl'}><Label style={{lineHeight: '25px', textAlign: 'center'}}>{items[1].productNumber}</Label></td>
                                <td colSpan={2} className={''}><Label style={{lineHeight: '25px', textAlign: 'center'}}>{items[1].productBloodGroupStr}</Label></td>
                            </tr>)}
                        </React.Fragment> : null}
                        </tbody>
                    </table>
                </ModalContent>
                <ModalControls>
                    {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش درخواست</Button>}
                    {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت درخواست</Button>}
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalPrint refer={this.ref.modalPrint}/>
        </React.Fragment>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'patientDiagnosticId':
                if (value[0]?.id != 5)
                    delete nextFields.patientDiagnosticStr;
                break;
            case 'patientFileCode':
                this.setState({patientFileInfo: undefined});
                break;
            default:
        }
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            if (!state.patientFileInfo) {
                new Notif({message: 'شماره پرونده معتبر نمی باشد.', theme: 'error'}).show();
                return;
            }
            ref.insert.current.loading();
            this.setState({error: null});

            SectionWashRequest.insert({
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId,
                patientDiagnosticId: state?.fields?.patientDiagnosticId[0]?.id,
                patientDiagnosticStr: state?.fields?.patientDiagnosticStr || '',
                requestReasonStr: state?.fields?.requestReasonStr,
                docterId: state?.fields?.docterId?.[0]?.id
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();
                ref.insert.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.insert.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {
                    patientFileCode: data?.patientFileCode,
                    patientDiagnosticId: data?.patientDiagnosticId,
                    patientDiagnosticStr: data?.patientDiagnosticStr,
                    docterId: [{id: data?.docterId}]
                },
                patientFileInfo: data.patientFileInfo,
                error: null
            });
        } else if (action === ModalAction.UPDATE || action === ModalAction.VIEW) {
            this.setState({
                data,
                action,
                fields: {},
                error: null,
                loading: 'در حال دریافت اطلاعات درخواست'
            });

            if (data?.sectionRequestId)
                HospitalWashRequest.data({sectionRequestId: data?.sectionRequestId})
                    .then(data => {
                        this.setState({
                            data: {
                                ...data,
                                patientFullName: `${data.patientFirstName} ${data.patientLastName}`
                            },
                            action,
                            fields: {
                                patientDiagnosticId: [{id: data?.patientDiagnosticId}],
                                patientDiagnosticStr: data?.otherPatientDiagnosticStr,
                                requestReasonStr: data?.requestReasonStr,
                                docterId: [{id: data?.docterId}]
                            },
                            patientFileInfo: {
                                patientFileCodeId: data.patientFileCodeId
                            },
                            error: null,
                            loading: null
                        });
                    })
                    .catch(message => {
                        new Notif({message, theme: 'error'}).show();

                        this.close();
                    });

            if (data?.hospitalRequestId)
                OrganizationWashRequest.data({hospitalRequestId: data?.hospitalRequestId})
                    .then(data => {
                        this.setState({
                            data,
                            action,
                            fields: {
                                patientDiagnosticId: [{id: data?.patientDiagnosticMainId}],
                                patientDiagnosticStr: data?.otherPatientDiagnosticStr,
                                requestReasonStr: data?.requestReasonStr,
                                docterId: [{id:data?.docterId}]
                            },
                            error: null,
                            loading: null
                        });
                    })
                    .catch(message => {
                        new Notif({message, theme: 'error'}).show();

                        this.close();
                    });
        }

        this.ref.modal.current.open()
            .then(_ => {
                if (action === ModalAction.INSERT) {
                    this.ref.patientFileCode.current.focus();
                }
            });
    }

    patientFileCodeSubmitHandler(value) {
        if (!value) {
            this.setState({patientFileInfo: undefined});
        }

        if (value) {
            this.setState({
                patientFileInfo: undefined,
                loading: 'در حال دریافت پرونده بیمار'
            });

            Patient.data({
                patientFileCode: value
            })
                .then(data => {
                    this.setState({
                        patientFileInfo: data,
                        loading: false
                    });
                })
                .catch(message => {
                    this.setState({
                        patientFileInfo: undefined,
                        loading: false,
                    }, _ => {
                        new Notif({message, theme: 'error'}).show();
                    });
                });
        }
    }

    updateClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});

            SectionWashRequest.update({
                sectionWashedRequestId: state.data?.sectionWashedRequestId,
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId,
                patientDiagnosticId: state?.fields?.patientDiagnosticId[0]?.id,
                patientDiagnosticStr: state?.fields?.patientDiagnosticStr || '',
                requestReasonStr: state?.fields?.requestReasonStr,
                docterId: state?.fields?.docterId?.[0]?.id
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();
                ref.update.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    validate() {
        const {ref} = this;
        const validate = Tool.validate(ref.patientFileCode,
            ref.patientDiagnosticId,
            ref.patientDiagnosticStr,
            ref.requestReasonStr,
            ref.docterId
        );

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        user: state.user
    };
};

export default connect(mapStateToProps)(ModalWashRequest);